import ProductCardSizeIcon from "@components/Icons/ProductCardSizeIcon";

const ProductListVariations = ({ variations }) => (
  <>
    <ProductCardSizeIcon />

    <div className="text-sm text-[#8B8C92] ml-2 leading-5">
      {variations.size} {variations.label || "variante"}
    </div>
  </>
);

export default ProductListVariations;
